<template>
  <div class="search-container" ref="searchToolbar">
    <v-btn icon color="white" @click.prevent="openSearchbar">
      <search-svg
    /></v-btn>
    <div v-show="showSearchInput" class="search-input-container elevation-2">
      <input
        :placeholder= "$t('searchToolbar.search')"
        class="search-input"
        ref="input"
        @keyup.enter="search"
        v-model="searchTerm"
        type="text"
      />
      <div class="button-holder elevet" @click="search">
        <enter-button />
      </div>
    </div>
  </div>
</template>
<script>
import EnterButton from '../_shared/svg/EnterButton.vue'
import SearchSvg from '../_shared/svg/SearchSvg.vue'
export default {
  components: { SearchSvg, EnterButton },
  name: 'SearchToolbar',
  data: () => ({
    searchTerm: '',
    showSearchInput: false
  }),
  methods: {
    search() {
      this.$router.push({
        name: 'search',
        query: {
          q: encodeURIComponent(this.searchTerm)
        }
      })
      this.showSearchInput = false
    },
    hideOnClickOutside(element) {
      const outsideSearchbarClickListener = (event) => {
        if (!element.contains(event.target)) {
          this.showSearchInput = false
        }
      }

      document.removeEventListener('click', outsideSearchbarClickListener)
      document.addEventListener('click', outsideSearchbarClickListener)
    },
    openSearchbar() {
      this.showSearchInput = !this.showSearchInput
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    }
  },

  // if we use ssr need to refactor this segment, becouse ssr not support mounted
  mounted() {
    this.hideOnClickOutside(this.$refs.searchToolbar)
  }
}
</script>
<style lang="scss" scoped>
@import '~vuetify/src/styles/settings/_variables';

.search-container {
  .search-input-container {
    position: fixed;
    top: 6rem;
    left: 0;
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
    height: 11rem;
    background: #eff0f3;
    display: flex;
    justify-content: center;
    align-items: center;

    .search-input {
      height: 5rem;
      font-size: 4rem;
      width: 100%;
      max-width: 92rem;
      margin-right: 0.5rem;

      &:focus {
        outline: none;
      }
    }

    .button-holder {
      background: black;
      color: white;
      box-shadow: 0px 5px 12px rgba(60, 65, 82, 0.31);
      padding: 1rem;
    }
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .search-container .search-input-container {
    padding: 0 1.6rem;
    .search-input {
      font-size: 3rem;
    }
  }
}
</style>
